import React, { createContext, useCallback, useContext, useState } from 'react';

type UpdateFormPageviewTrackingContextValue = () => void;

const UpdateFormPageviewTrackingContext = createContext<UpdateFormPageviewTrackingContextValue | undefined>(undefined);
const FormPageviewTrackedContext = createContext<boolean | undefined>(undefined);

export const ApplyFormPageviewTrackingProvider: React.FC = ({ children }) => {
  const [isFormPageviewTracked, setIsFormPageviewTracked] = useState(false);

  const setIsPageviewTracked = useCallback((): void => {
    setIsFormPageviewTracked(true);
  }, []);

  return (
    <UpdateFormPageviewTrackingContext.Provider value={setIsPageviewTracked}>
      <FormPageviewTrackedContext.Provider value={isFormPageviewTracked}>
        {children}
      </FormPageviewTrackedContext.Provider>
    </UpdateFormPageviewTrackingContext.Provider>
  );
};

export const useUpdateFormPageviewTracking = (): UpdateFormPageviewTrackingContextValue => {
  const updatePrefilledFieldValue = useContext(UpdateFormPageviewTrackingContext);

  if (typeof updatePrefilledFieldValue === 'undefined') {
    throw new Error('useUpdateFormPageviewTracking must be used within an ApplyFormPageviewTrackingContext');
  }

  return updatePrefilledFieldValue;
};

export const useIsFormPageviewTracked = (): boolean => {
  const isFormPageviewTracked = useContext(FormPageviewTrackedContext);

  if (typeof isFormPageviewTracked === 'undefined') {
    throw new Error('useIsFormPageviewTracked must be used within an ApplyFormPageviewTrackingContext');
  }

  return isFormPageviewTracked;
};
